import { Col, Row } from 'antd'
import React, { FC, useState } from 'react'
import CardInProgress from './CardInProgress'
import CardCancel from './CardCancel'
import CardReport from "./CardReportOverall";
import CardComplete from './CardComplete';
import CardOpen from './CardOpen';
 
interface TopRowReportProps {
  daterangePicker: [string, string]
}

const TopRowReport:FC<TopRowReportProps> = ({ daterangePicker }) => {
  const [selectPeriod, setSelectPeriod] = useState('') //month

  return (
    <Row gutter={[16, 16]}>
    <Col span={24}>
      <CardReport daterangePicker={daterangePicker} selectPeriod={selectPeriod} setSelectPeriod={setSelectPeriod} />
    </Col>
    
    <Col span={8}>
      <CardInProgress daterangePicker={daterangePicker} selectPeriod={selectPeriod}   />
    </Col>
    <Col span={8}>
      <CardComplete daterangePicker={daterangePicker} selectPeriod={selectPeriod} />
    </Col>

    <Col span={8}>
      <CardCancel daterangePicker={daterangePicker} selectPeriod={selectPeriod} />
    </Col>
 

  </Row>
  )
}

export default TopRowReport